module.exports = __webpack_public_path__ + "img/downloadImg_5.b6d4fed2.png";